import { CarouselModule } from '@app/components/carousel/carousel.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';

import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { SliderItemsComponent } from './slider-items/slider-items.component';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import {FormsModule} from "@angular/forms";
import {IconsModule} from "@app/components/icons/icons.module";

@NgModule({
  declarations: [SearchComponent, SliderItemsComponent],
  imports: [
    CommonModule,
    SharedModule,
    SearchRoutingModule,
    ContainerScrollModule,
    ListItemsModule,
    CarouselModule,
    IconsModule
  ]
})
export class SearchModule { }
